module.exports = __webpack_public_path__ + "static/media/cobler.64324fda.ogg";